import type { ColDef, ValueGetterParams } from 'ag-grid-enterprise'
import type { IBadgeCellRendererParams } from '~/types/badge'
import type { IInAppFeaturesGroup } from '~/types/iap'

import BadgeCellRenderer from '~/components/CellRenderers/BadgeCellRenderer'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { badgeColDef, textColDef } from '~/utils/table'

const columns: ColDef[] = [
  textColDef(TextCellRenderer, {
    field: 'name',
    headerName: 'Features Group Name',
  }),
  badgeColDef(BadgeCellRenderer, {
    headerName: 'Features IDs',
    sortable: false,
    valueGetter: ({ data }: ValueGetterParams<IInAppFeaturesGroup>): IBadgeCellRendererParams | undefined => {
      if (!data) return undefined

      const { feature_ids } = data

      return {
        data: feature_ids?.map((id) => ({ id, name: id })) || [],
        type: 'default',
      }
    },
  }),
]

export default columns
